import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useRequest } from "../../utils";
import Axios from "axios";
import { storage } from "../../utils";
import moment from "jalali-moment";

const publicationLabel = (post) => {
  const value = post?.published_at || post?.creation_date;
  return value ? moment(value).locale("fa").format("YYYY/MM/DD HH:mm") : "—";
};

const GetBlogPosts = (props) => {
  const [
    blog_posts_error,
    blog_posts_loading,
    blog_posts_data,
    blog_posts_function,
  ] = useRequest({
    method: "get",
    url: "/get_blog_posts",
  });

  const handleDelete = (id) => {
    storage.load("token").then((tok) => {
      if (!tok) return;
      Axios.post(
        "/delete_blog_post",
        { id },
        { headers: { "x-auth": tok } }
      ).then(() => blog_posts_function());
    });
  };

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row"></div>
      <div class="content-body">
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {blog_posts_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">عنوان</th>
                <th className="table--title">دسته‌بندی</th>
                <th className="table--title">تاریخ انتشار</th>
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              blog_posts_data?.data?.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>{item.category_id?.name || "بدون دسته‌بندی"}</td>
                  <td>{publicationLabel(item)}</td>
                  <td>
                    <Link to={"/dashboard/editBlog/" + item._id}>
                      <button
                        type="button"
                        class="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                    <button
                      type="button"
                      class="btn btn-danger round mr-1 mb-1 btn-sm"
                      onClick={() => handleDelete(item._id)}
                    >
                      حذف
                    </button>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetBlogPosts };
